import { useTranslation } from "react-i18next";

export enum USER_GROUP_TYPE {
  STANDARD = "STANDARD",
  COLLABORATOR = "COLLABORATOR",
  CUSTOMER = "CUSTOMER",
}

export const getUserGroupTypeEnum = (userGroupType: any): USER_GROUP_TYPE => {
  return userGroupType?.Name as USER_GROUP_TYPE;
};

export const getTranslatedUserGroupName = (userGroup: any, t: any): string => {
  switch (getUserGroupTypeEnum(userGroup)) {
    case USER_GROUP_TYPE.COLLABORATOR:
      return t(`usergroupenum:COLLABORATOR`);
    case USER_GROUP_TYPE.CUSTOMER:
      return t(`usergroupenum:CUSTOMER`);
    case USER_GROUP_TYPE.STANDARD:
      return t(`usergroupenum:STANDARD`);
    default:
      return t(`usergroupenum:UNKNOWN`);
  }
};
